import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

function Kbd({ className, ...props }: ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "pointer-events-none inline-flex h-5 min-w-5 items-center justify-center gap-1 rounded-[4px] bg-muted px-1.5 font-mono text-[11px] text-muted-foreground select-none",
        className,
      )}
      {...props}
    />
  );
}

export { Kbd };
